import React from "react"
//import I18n from "i18n-js/index.js.erb"
import PageBuilderActions from "./actions/PageBuilderActions"

class PageChart extends React.Component {

  constructor(props) {
    super(props);

    // console.log('PageChart', this.props);

    if (this.props.chart_id) {
      var chart_id = this.props.chart_id
    } else {
      var chart_id = this.props.charts[0].id
    }

    // console.log('chart_id', chart_id)

    this.state = {
      chart_id: chart_id
    }

    this.findChart = this.findChart.bind(this);
    this.onChangeChart = this.onChangeChart.bind(this);
  }

  componentDidMount() {
    var self = this;
    setTimeout(function () {
      PageBuilderActions.setChart(self.props.rowId, self.props.id, self.state.chart_id);
    }, 0);
  }

  render() {
    // console.log('PageChart', this.props);
    var chart = this.findChart();
    // console.log('chart', chart)
    var options = this.props.charts.map(function (chart) {
      return <option key={chart.id} value={chart.id}>{chart.name}</option>
    });
    return (
      <div className="PageChart btn-start">
        <span className="ss-piechart"></span>
        <select className="form-control" onChange={this.onChangeChart} value={this.state.chart_id}>
          {options}
        </select>
        <div className="select">{chart.name}</div>
      </div>
    );
  }

  /**
  * Change handlers
  */

  onChangeChart(e) {
    var self = this;
    this.setState({chart_id: e.target.value}, function () {
      PageBuilderActions.setChart(self.props.rowId, self.props.id, self.state.chart_id);
    });
  }

  /**
  * Helper functions
  */

  findChart() {
    for (var i = 0, ilen = this.props.charts.length; i < ilen; i++) {
      if (this.props.charts[i].id === this.state.chart_id) {
        return this.props.charts[i];
      }
    }
    return this.props.charts[0]
  }

};

export default PageChart
